import { ActivatedRoute } from '@angular/router';

import { Component } from '@angular/core';
import { AbstractComponent } from '../../../../../core/common/component/AbstractComponent';

import { Title } from '@angular/platform-browser';

import { ToastrService } from 'ngx-toastr';
import { TenantMenuService } from './TenantMenuService';

@Component({
  selector: 'app-tenant-menu',
  templateUrl: './TenantMenu.html',
  styleUrls: ['./TenantMenu.scss']
})
export class TenantMenuComponent extends AbstractComponent {

  public scope = {
    tenantCd : "",
    tenant : null,
    menuitems : [],
    wait : false,
  }


  public constructor(
    private title: Title,
    private toastr: ToastrService,
    private service : TenantMenuService,
    private route: ActivatedRoute) {
    super();
    this.title.setTitle("Menu Setting");
    
  }
  /**  */
  public componentWillMount() {
    this.route.params.subscribe(params => {
      this.scope.tenantCd = params.tenantCd;
      this.service.getTenant(this.scope.tenantCd).subscribe((res:any) => {
        this.scope.tenant = res;
        this.service.get(this.scope.tenantCd).subscribe((res:any) => {
          this.scope.menuitems = res;
          for (let menu of this.scope.menuitems) {
            let menuItem = this.scope.tenant.menuRole.find(e => menu.path == e.path)
            if (menuItem) {
              menu.select = true;
            } else {
              menu.select = false;
            }
          }
        });

      });
    });
  }


  /** 表示 */
  public render() {
  }



  public isAllCehck() {
    if (this.scope.menuitems.find(e => e.select )) {
      return true;
    } else {
      return false;
    }
  }

  public allToggle() {
    if (this.isAllCehck()) {
      this.scope.menuitems.map(e => e.select = false);
    } else {
      this.scope.menuitems.map(e => e.select = true);
    }
  }
  
  public toggle(menu) {
    menu.select = !menu.select;
  }


  public save() {
    this.service.save(this.scope.tenantCd, this.scope.menuitems).subscribe(e => {

      this.toastr.success('Menu saved is successful');

    })
  }

  public editTenant() {}

}
